import { useTranslation } from "react-i18next";
import { useMyTodos } from "~/api/v2/useMyTodos";
import { CenterSpinner } from "~/atoms/spinner";
import { DashboardCard } from "../molecules/DashboardCard";
import TodoDataTable from "~/molecules/TodoDataTable";
import { TodoEmpty } from "~/molecules/TodoEmpty";

const TodoContainer = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useMyTodos();

  const title = t(($) => $.dashboard.myTodos.title);

  if (isLoading) {
    return (
      <DashboardCard title={title} className="h-80">
        <CenterSpinner />
      </DashboardCard>
    );
  }

  if (data === undefined) {
    return (
      <DashboardCard title={title}>
        <TodoEmpty className="h-full" />
      </DashboardCard>
    );
  }

  return (
    <DashboardCard title={title}>
      <TodoDataTable todos={data} />
    </DashboardCard>
  );
};

export default TodoContainer;
